// ---- imports first (to satisfy eslint import/first) ----
import React from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@mui/material/styles";
import "bootstrap/dist/css/bootstrap.min.css";

import App from "./App";
import { MyContextProvider } from "./MyContext";
import { DataCacheProvider } from "./DataCacheContext";
import * as serviceWorker from "./serviceWorker";
import myCustomTheme from "./theme";
import { loadSuperAppConfig } from "./lib/superappConfig";

// Kick off loading the SuperApp config early (non-blocking)
loadSuperAppConfig("Ben-test"); // use our isolated config doc

// Create and render root
const root = createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider theme={myCustomTheme}>
    <MyContextProvider>
      <DataCacheProvider>
        <App />
      </DataCacheProvider>
    </MyContextProvider>
  </ThemeProvider>
);

// CRA service worker default
serviceWorker.unregister();
